import { ScrollView } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { Query } from '@/utils/react-query/Queries';
import OrganizationSetupCard from '@/components/Dashboard/OrganizationSetupCard';

export default function OrganizationSetupScreen() {
    const { data: user } = Query.people.loggedInUser();
    return <ScrollView contentContainerStyle={styles.content} keyboardShouldPersistTaps="handled">
        <OrganizationSetupCard user={user} expanded />
    </ScrollView>;
}

const styles = StyleSheet.create(({ spacing }) => ({
    content: { padding: spacing.lg, width: '100%', maxWidth: 800, alignSelf: 'center', paddingBottom: spacing.xxl },
}));
